/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

export interface EnvironmentModel {
  /**
   * determina env production
   */
  production: boolean;

  /**
   * codice per identificare l'env
   */
  envCode: string;

  /**
   * codice applicazione
   */
  appCode: string;

  /**
   * base url per le api
   */
  apiBaseUrl: string;

  /**
   * base url per le api di login
   */
  securityBaseUrl: string;

  /**
   * abilita modalità dev
   */
  devMode?: boolean;
}
